import api from 'api'

export type CreatePositionParams = {
  companyId: number
  name: string
  about?: string
  positionTemplateId?: number
}

export type CreatePositionResponse = {
  id: number
  name: string
}

export const createPosition = async (
  params: CreatePositionParams
): Promise<CreatePositionResponse> => {
  const result = await api.post<CreatePositionResponse>(
    '/admin/positions',
    params
  )
  return result.data
}
